import { Component, OnDestroy } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnDestroy {
  title = 'Sistema Loca9Motos';

  private routerSub?: Subscription;
  private pendingScrollY: number | null = null;
  private pendingFromUrl: string | null = null;

  constructor(router: Router) {
    this.routerSub = router.events
      .pipe(filter((e): e is NavigationStart | NavigationEnd =>
        e instanceof NavigationStart || e instanceof NavigationEnd))
      .subscribe(event => {
        if (event instanceof NavigationStart) {
          this.pendingFromUrl = router.url;
          this.pendingScrollY = this.readScrollY();
          return;
        }

        if (this.shouldKeepScroll(this.pendingFromUrl, event.urlAfterRedirects)
            && this.pendingScrollY != null) {
          const y = this.pendingScrollY;
          requestAnimationFrame(() => this.writeScrollY(y));
          setTimeout(() => this.writeScrollY(y), 50);
        }

        this.pendingScrollY = null;
        this.pendingFromUrl = null;
      });
  }

  ngOnDestroy(): void {
    this.routerSub?.unsubscribe();
  }

  private shouldKeepScroll(fromUrl: string | null, toUrl: string): boolean {
    if (!fromUrl) return false;
    const from = this.b2bContractId(fromUrl);
    const to = this.b2bContractId(toUrl);
    return from != null && from === to;
  }

  private b2bContractId(url: string): string | null {
    const match = url.split('?')[0].match(/\/b2b\/contracts\/(\d+)/);
    return match ? match[1] : null;
  }

  private readScrollY(): number {
    return window.scrollY
      || document.documentElement.scrollTop
      || document.body.scrollTop
      || 0;
  }

  private writeScrollY(y: number): void {
    window.scrollTo(0, y);
    document.documentElement.scrollTop = y;
    document.body.scrollTop = y;
  }
}
